import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

const IMAGE_CONFIG: LocalImageConfig = {
	default: '00214ca8f8037154c9cec7e80a838471.png',
	fr: 'a3fdffc22b63d1dc17bc94ff84e827a8.png',
};

export const LyricsTranslated: FunctionComponent = () => {
	const {t} = useTranslation();
	const src = useLocalImage(IMAGE_CONFIG);

	return (
		<LandingIllustrationSection
			imagePosition="left"
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'lyricslandingpage_title_discovertranslatedlyrics_standalone-web',
							{ns: 'lyrics'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'lyricslandingpage_text_discovertranslatedlyrics_standalone-web',
							{ns: 'lyrics'},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					aspectRatio="1440/840"
					sizes={{base: '100vw', sm: '50vw'}}
					h={{base: '250px', md: '100%'}}
					src={src}
					alt={t('metatag_title_translatedlyrics_standalone-web', {
						ns: 'common',
					})}
				/>
			}
		/>
	);
};
